define('models/CartProductCollection',['underscore', 'jquery', 'ObjectCollection', 'ApiRequest', 'LocalStorage', 'router', 'app', 'models/CartProductModel',

'TagCommander'
], function (_, $, ObjectCollection, ApiRequest, LocalStorage, router, app, CartProductModel, TagCommander)
{
    //
    // Collection CartProduct
    //
    var CartProductCollectionPrototype = {

        name: 'CartProductCollection',
        route: 'apiCartProductCollection',
        model: CartProductModel,
        initialize: function () {
            var collection = this;
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(collection, arguments);
            //
            collection.on('sync', collection.onSync, collection);
            //
        },
        attachCart: function (cart, type, model)
        {
            // attache une référence panier au Produit
            // obligatoire pour obtenir des prix contextualisés
            //
            var collection = this,
                // baseModel, permet de gérer le cas général (cart)
                // et le cas d'un produit attaché à un autre (accompagnement)
                baseModel = model ? model : cart,
                wrappedProducts = _(baseModel.get(type)); // récupère les produits
            //
            collection.cart = cart;
            collection.type = type;
            baseModel.on("change:" + type, collection.changeModelProducts, collection);
            collection.on("change add remove delete", collection.onChange, collection);
            //
            var models =
                // map la référence du panier sur les produits
                wrappedProducts.map(function(product){
                    return _(product).extend({cart:cart,type:type});
                });
            //
            // ajoutes les models à la collection
            //
            collection.reset(models);
            //
            // suppression des références circulaire au panier
            _(models).each(function(ref){
                delete ref.cart;
            });
        },
        getProductsByUniqueId:function(id_product){
          var collection = this, products=[];
            collection.each(function(p){
               if(p.id===id_product || p.getProduct().id === id_product){
                   products.push(p);
               }
               _(p.get('accompagnements')).find(function(a){
                   if(a.id_product === id_product){
                       products.push(p);
                   }
               })
            });
          return products;
        },
        onChange:function(){
            // quand la collection change...
            // on trigger sur le panier un productsChange
            var cart = this.cart;
            cart.trigger('productsChange',cart)
        },
        changeModelProducts: function (baseModel, products)
        {
            // baseModel peut être ou bien le panier, ou bien un menu
            this.set(products);
        },
        updateProduct: function (method, id_cart_product, quantity, options)
        {
            id_cart_product = id_cart_product.toString();

            var collection = this,
                cart = collection.cart,
                product = collection.findWhere({id_cart_product: id_cart_product}),
                data = {},
                sidedish;

            if (product) {
                data = product.pick(['id_product','id_cart_product']);
            }else{
                data.id_product = id_cart_product;
            }

            if(!_.isUndefined(options)){
                sidedish = options.sidedish;
                if(!_.isUndefined(sidedish)){
                    data.sidedish = sidedish;
                }
            }

            // si une quantité est envoyée, même en delete,
            // l'objet ne sera pas supprimé
            if (quantity != 0) {
                // quantity est une différence pas une valeur
                data.quantity = quantity;
            }
            if (method == 'DELETE') {
                // l'operation delete supprime tous les items
                delete data.quantity;
                TagCommander.tc_delete_product(this,id_cart_product, quantity, 'block_checkout_products');
            }else
            {
                TagCommander.tc_add_product(this,id_cart_product, quantity, 'block_product_options');
            }

            return this.pipeAppHttpHeaders(
                ApiRequest('CartProductCollection',data,{id_cart:cart.id},{method: method})
            ).done(function (data){
                    cart.set(data);
                })
                .fail(function (err, status){
                    switch(err.status){
                        case 0 :
                            app.trigger('networkError',err);
                            break;
                        default :
                            app.alert(t("Le produit n'a pas pu être ajouté", 'Cart'));
                    }
                    cart.trigger('addProductFail',data);
                    // TODO translation
                })
        },
        mulipleUpdateProduct: function (method, multipleProduct)
        {
            var collection = this,
                cart = collection.cart,
                products  = {'products':[]};

            _(multipleProduct).each(function (product)
            {
                var id_cart_product = product.id_cart_product.toString(),
                    quantity = product.qty,
                    data = {
                        id_product:id_cart_product
                    };

                if (quantity != 0) {
                    data.quantity = quantity;
                }
                if(method == 'DELETE'){
                    // l'operation delete supprime tous les items
                    delete data.quantity;
                }

                if (method == 'DELETE')
                {
                    TagCommander.tc_delete_product(this,id_cart_product, quantity, 'block_checkout_products');
                }else
                {
                    TagCommander.tc_add_product(this,id_cart_product, quantity, 'block_product_options');
                }
                products.products.push(data);

            }, collection);

            return this.pipeAppHttpHeaders(
                ApiRequest('CartMultipleProductCollection',products,{id_cart:cart.id},{method: method})
            ).done(function (data) {
                // success
                cart.set(data);
            }).fail(function (a, status, c) {
                // en cas d'erreur serveur
                // TODO translation
                app.alert(t("Le produit n'a pas pu être ajouté",'Cart'));
                cart.trigger('addProductFail',products);
            });

        },

        deleteProduct: function (id_cart_product, quantity)
        {
            return this.updateProduct('DELETE', id_cart_product, quantity);
        },

        addMultipleProduct: function (multipleProduct)
        {
            return this.mulipleUpdateProduct('POST', multipleProduct);
        },

        addProduct: function (id_cart_product, quantity, options)
        {
            if(_.isUndefined(quantity)){ quantity = 1}

            return this.updateProduct('POST', id_cart_product, quantity, options);
        },
        updateQuantityProduct: function (id_cart_product, quantity)
        {
            return this.updateProduct('POST', id_cart_product, quantity);
        },
        updateProductSidedish: function (id_cart_product, sidedish){
            var cartProduct = this.get(id_cart_product);
            if(cartProduct){
                // sidedish est un tableau
                this.updateProduct('POST', id_cart_product, 0, {sidedish:sidedish});
            }
        }
    };

    var CartProductCollection = ObjectCollection
    //.extend(LocalStorage)
        .extend(CartProductCollectionPrototype);
CartProductModel.CartProductCollection = CartProductCollection;
    return CartProductCollection;
});
